import { Checkbox, Typography } from "@callcenter/design-system"
import type { Dispatch, SetStateAction } from "react"
import { t } from "i18next"

import styles from "./mobile-application.module.pcss"

type Props = {
  isEnabledMobileNotifications: boolean
  setEnabledMobileNotifications: Dispatch<SetStateAction<boolean>>
}

export const MobileApplicationSettings = ({ isEnabledMobileNotifications, setEnabledMobileNotifications }: Props) => (
  <div className={styles.container}>
    <Typography.Body1>
      {t("userProfile_userProfileSidePanel_sectionHeading_mobileApplicationSettings_header")}
    </Typography.Body1>
    <div className={styles.checkbox}>
      <Checkbox isValue={isEnabledMobileNotifications} onChange={setEnabledMobileNotifications}>
        {t("userProfile_userProfileSidePanel_sectionHeading_mobileApplicationSettings_enableNotifications")}
      </Checkbox>
    </div>
  </div>
)
